import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { ArrowIconWrapper, MenuButtonWrapper, MenuItemsNavigation } from 'src/components/Menu/Menu.style';
import { CustomerMenuItemsState } from './CustomerMenuItems.state';
import { useCommon } from 'src/AppState/Common';
import { ConfigState } from 'src/AppState/ConfigState/ConfigState';

interface CustomerMenuItemsType {
    id: number;
    onQueryAudits: (
        id: string,
        topic: string,
        tag: string | Array<string>,
        filterName: string | null
    ) => (e: React.MouseEvent) => void;
}

export const CustomerMenuItems = observer((props: CustomerMenuItemsType): JSX.Element | null => {
    const common = useCommon();
    const { routerBackoffice, models } = useAppStateContext();
    const {
        config: { isPEP, showNewCustomerSettings, promotionHistoryEnabled, idMission },
    } = ConfigState.get(common);
    const { id, onQueryAudits } = props;

    const [state] = useState(() => new CustomerMenuItemsState(routerBackoffice, models, () => id));

    return (
        <MenuItemsNavigation>
            {state.menuItems.map((linkItem) => (
                <MenuButtonWrapper
                    key={linkItem.id}
                    isActive={state.isTabActive(linkItem.id)}
                    onClick={linkItem.onClick}
                    data-test={`${linkItem.id}-menu`}
                >
                    {linkItem.label}
                    <ArrowIconWrapper
                        isActive={state.isTabActive(linkItem.id)}
                        position='right'
                    />
                </MenuButtonWrapper>
            ))}

            {/* New customer settings - in_progress */}
            {showNewCustomerSettings && (
                <MenuButtonWrapper
                    key='customer-settings-new'
                    isActive={state.isTabActive('customer-settings-new')}
                    onClick={(): void => routerBackoffice.redirectToCustomerCustomerSettingsNew()}
                    data-test='customer-settings-menu-new'
                >
                    Customer settings New
                    <ArrowIconWrapper
                        isActive={state.isTabActive('customer-settings-new')}
                        position='right'
                    />
                </MenuButtonWrapper>
            )}

            {/* Audit links */}
            <MenuButtonWrapper
                isActive={false}
                onClick={(e): void => {
                    e.preventDefault();
                    const url = `/trading?tab=payment-search&payment.parameters={"accountId":${id}}`;
                    window.open(url, '_blank');
                }}
                data-test='payment-history-menu'
            >
                Payment History
                <ArrowIconWrapper
                    isActive={false}
                    position='right'
                />
            </MenuButtonWrapper>

            <MenuButtonWrapper
                isActive={false}
                onClick={(e): void => {
                    e.preventDefault();
                    const url = `/trading?tab=bet-search&bet.parameters={"accountId":${id},"sort":"-placedAt", "history": true, "summary": true}`;
                    window.open(url, '_blank');
                }}
                data-test='bet-history-menu'
            >
                Bet History
                <ArrowIconWrapper
                    isActive={false}
                    position='right'
                />
            </MenuButtonWrapper>
            {promotionHistoryEnabled ? (
                <MenuButtonWrapper
                    isActive={state.isTabActive('customer-promotion-history')}
                    onClick={(): void => routerBackoffice.redirectToCustomerPromotionHistory()}
                    data-test='account-promotion-history-menu'
                >
                    Promotion History
                    <ArrowIconWrapper
                        isActive={state.isTabActive('customer-promotion-history')}
                        position='right'
                    />
                </MenuButtonWrapper>
            ) : null}

            <MenuButtonWrapper
                isActive={false}
                onClick={onQueryAudits(`accounts_update_account-${id}`, 'accounts_update', `account-${id}`, null)}
                data-test='account-audit-menu'
            >
                Account Audit
                <ArrowIconWrapper
                    isActive={false}
                    position='right'
                />
            </MenuButtonWrapper>

            <MenuButtonWrapper
                isActive={false}
                onClick={onQueryAudits(
                    `accounts_update_account-${id}`,
                    'accounts_login',
                    `account-customer-${id}`,
                    null
                )}
                data-test='session-audit-menu'
            >
                Session Audit
                <ArrowIconWrapper
                    isActive={false}
                    position='right'
                />
            </MenuButtonWrapper>

            {idMission && (
                <MenuButtonWrapper
                    isActive={false}
                    onClick={(): void => {
                        routerBackoffice.setParamInNamespace('customers', 'audits', 'idMissionAudit');
                    }}
                    data-test='id-mission-audit-menu'
                >
                    EKYC Panel
                    <ArrowIconWrapper
                        isActive={false}
                        position='right'
                    />
                </MenuButtonWrapper>
            )}

            <MenuButtonWrapper
                isActive={false}
                onClick={onQueryAudits(`chats_account-${id}`, 'chats', `account-${id}`, null)}
                data-test='chat-audit-menu'
            >
                Chat Audit
                <ArrowIconWrapper
                    isActive={false}
                    position='right'
                />
            </MenuButtonWrapper>

            <MenuButtonWrapper
                isActive={false}
                onClick={onQueryAudits(`betting_referred_bets-${id}`, 'betting_referred_bets', `account-${id}`, null)}
                data-test='bet-referral-audit-menu'
            >
                Bet Referral Audit
                <ArrowIconWrapper
                    isActive={false}
                    position='right'
                />
            </MenuButtonWrapper>

            <MenuButtonWrapper
                isActive={false}
                onClick={(): void => {
                    routerBackoffice.setParamInNamespace('customers', 'audits', 'affordabilityAudit');
                }}
                data-test='affordability-audit-menu'
            >
                Affordability Audit
                <ArrowIconWrapper
                    isActive={false}
                    position='right'
                />
            </MenuButtonWrapper>

            {isPEP && state.isKycWatchlist() ? (
                <MenuButtonWrapper
                    isActive={false}
                    onClick={(): void => {
                        routerBackoffice.setParamInNamespace('customers', 'xml-data', `${id}`);
                    }}
                    data-test='view-callvalidate-menu'
                >
                    View CallValidate
                    <ArrowIconWrapper
                        isActive={false}
                        position='right'
                    />
                </MenuButtonWrapper>
            ) : null}
        </MenuItemsNavigation>
    );
});
